const MKSpesialHelper = {
  parseDetailsForCreateUpdate(MKSpesialDetails) {
    let termParsed = MKSpesialDetails.term.id_term;
    let jenisSidangParsed =
      MKSpesialDetails.jenis_sidang.label ?? MKSpesialDetails.jenis_sidang;
    let mahasiswaParsed = MKSpesialDetails.mahasiswa.map(
      (mahasiswa) => mahasiswa.id_mahasiswa
    );
    let pembimbingParsed = MKSpesialDetails.pembimbing.map(
      (pembimbing) => pembimbing.id_dosen
    );
    let saraPengujiParsed = MKSpesialDetails.saran_penguji.map(
      (penguji) => penguji.id_dosen
    );
    return {
      ...MKSpesialDetails,
      term: termParsed,
      jenis_sidang: jenisSidangParsed,
      mahasiswa: mahasiswaParsed,
      pembimbing: pembimbingParsed,
      saran_penguji: saraPengujiParsed,
    };
  },
};

export default MKSpesialHelper;
